module.exports = __webpack_public_path__ + "img/logo.7c9609e4.png";